import { Component,  Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityRequest } from 'globals/store/programs.data';
import { publicHelpers } from './../../helpers/public-helpers';
import { ExpandingWrapperComponent } from 'src/app/components/wrappers/expanding-wrapper.component';
import { DatePipe, TitleCasePipe } from '@angular/common';

@Component({
    selector: 'staging-requests',
    template: `
<expanding-wrapper
  *ngFor="let stagingRequest of stagingRequests"
  class="staging-request"
  [title]="stagingRequest.by + ' (' + (stagingRequest.type | titlecase) + ')'"
  [borderGreyOnCollapse]="true"
>
  <div [innerHTML]="helpers.strWithBreak(stagingRequest.requestText)"></div>
  <div class="staging-request-info">
    {{ stagingRequest.created === stagingRequest.modified ? 'Created' : 'Modified' }} by {{ stagingRequest.type }} ({{ stagingRequest.by }}), {{ stagingRequest.modified | date: "HH:MM on d MMMM y" }}
  </div>
</expanding-wrapper>
`,
    styleUrls: ['./staging-requests.scss'],
    standalone: true,
    imports: [ExpandingWrapperComponent, CommonModule, TitleCasePipe, DatePipe],
})
export class StagingRequestsComponent {
  @Input() stagingRequests: EntityRequest[]
  helpers = publicHelpers
}
